import { DataBean } from "../DataBean";

export class FixedAssetExtraData extends DataBean {

  public async getFixedAssetExtraDataCatalogPorPropiedades(properties: any, maxRows: number): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "java.util.List_getFixedAssetExtraDataCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async deleteFixedAssetExtraData(idfixedassetextradata: number): Promise<any> {
    return this.getCustomService("ProcessContractERP", "boolean_deleteFixedAssetExtraData_Number", [idfixedassetextradata]);
  }

  public async getFixedAssetsItemsProps(idEmployee: number, codeForm: string): Promise<any> {
    return this.getCustomService("CacheOptions", "java.util.Map_getFixedAssetsItemsProps_Number_String", [idEmployee, codeForm]);
  }

  public async importFixedAssetsExtraData(idEmplyee: number, media: string, mediaContext: string): Promise<any> {
    return this.getCustomService("CacheOptions", "java.util.List_importFixedAssetsExtraData_Number_String_String", [idEmplyee, media, mediaContext]);
  }

  public async updateFixedAssetExtraData(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.orange.finance.processcontract.bean.FixedAssetExtraData_updateFixedAssetExtraData_com.orange.finance.processcontract.bean.FixedAssetExtraData",
      [
        {
          "DataBeanProperties": bean,
          "DataBeanName": "com.orange.finance.processcontract.bean.FixedAssetExtraData"
        },
      ]
    );
  }
}
